'use strict';

module.exports = ['$timeout',
    function ($timeout) {

        return {
            restrict: 'E',
            scope: {
                label: '@',
                model: '=rmModel',
                originalId: '=',
                allowAll: '=',
                modelTypes: '=',
                disabled: '=',
                changeCallback: '&rmChange',
            },
            templateUrl: '/partial/app.directives.model_type_select',
            link: function (scope, element, attributes) {

                scope.showModel = (modelType) => {
                    if(scope.allowAll) return true;
                    if(modelType.id == scope.originalId) return true;

                    return !(modelType.options && modelType.options.hidden);
                };

                scope.$watch('model', (newValue, oldValue, scope) => {
                    if(!(typeof newValue === "undefined") && !(typeof oldValue === "undefined")) {
                        scope.changeCallback();
                    }
                })
            }
        };
    }
];

